import {
  FaActionTracker,
  StructuredLogger,
} from '@brighthub/structured-logging';
import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { MessageService } from 'primeng/api';
import { CreditOverviewAnalytics } from '../analytics/credit-overview-analytics';
import { CREDIT_OVERVIEW_API } from '../credit-overview-api.token';

@Injectable({ providedIn: 'root' })
export class CreditOverviewSendAction {
  private readonly _actionLogs = new FaActionTracker(inject(StructuredLogger));
  private readonly _api = inject(CREDIT_OVERVIEW_API);
  private readonly _messages = inject(MessageService);
  private readonly _analytics = inject(CreditOverviewAnalytics);

  readonly sending = signal(false);

  async send(clientId: string): Promise<boolean> {
    if (this.sending()) return false;

    this.sending.set(true);
    try {
      await this._actionLogs.run(
        'credit_overview.send',
        clientId,
        async (attempt) => {
          attempt.stage = 'acceptance';
          attempt.accepted = true;
          await attempt.request(
            firstValueFrom(this._api.inviteClient(clientId)),
          );
        },
      );
      this._analytics.linkSent();
      this._messages.add({
        severity: 'success',
        summary: 'Sent',
        detail:
          'Credit link sent to the client. It may take a couple of minutes to arrive.',
      });
      return true;
    } catch {
      this._messages.add({
        severity: 'error',
        summary: 'Send failed',
        detail: 'Could not send the credit link to the client.',
      });
      return false;
    } finally {
      this.sending.set(false);
    }
  }
}
